import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/la/admin/purchase/getAllList',
      data
    });
  },
  create(data) {
    return http.post({
      url: '/la/admin/purchase/createPurchase',
      data
    });
  },
  update(data) {
    return http.post({
      url: '/la/admin/purchase/changePurchase',
      data
    });
  },
  updateContent(data) {
    return http.post({
      url: '/la/admin/purchase/language/update',
      data
    });
  },
  getCoinTypeList() {
    return http.get({
      url: '/la/admin/coin/allDisplay'
    });
  },
  getPurchaseLanguageContent(data) {
    return http.get({
      url: '/la/admin/purchase/language',
      data
    });
  },
  getRelativePrice(data) {
    return http.get({
      url: '/la/admin/purchase/getRecommendedPrice',
      data
    });
  },
  setOpenPrice(data) {
    return http.post({
      url: '/la/admin/purchase/setOpenPrice',
      data,
      dataType: 'form'
    });
  },
  getOneButton(data) {
    return http.get({
      url: '/la/admin/purchase/getOneButton',
      data
    });
  },
  getSomeButton(data) {
    return http.get({
      url: '/la/admin/purchase/getBatchButton',
      data
    });
  },
  setOneButton(data) {
    return http.post({
      url: '/la/admin/purchase/updateOneButton',
      data,
      dataType: 'form'
    });
  },
  setSomeButton(data) {
    return http.post({
      url: '/la/admin/purchase/updateBatchButton',
      data,
      dataType: 'form'
    });
  },
  getDayOfAmount(data) {
    return http.get({
      url: ' /la/admin/user/snapshot/select',
      data
    });
  },
  setDayOfAmount(data) {
    return http.get({
      url: '/la/admin/user/snapshot/switch',
      data
    });
  },
  Addpeople(data) {
    return http.post({
      url: '/la/admin/purchase/updatePersonNum',
      data,
      dataType: 'form'
    });
  },
  getaward(data) {
    return http.get({
      url: '/la/admin/purchase/getAllBallot',
      data
    });
  },
  confirmGitNum(data) {
    return http.post({
      url: '/la/admin/purchase/confirmGitNum',
      data,
      dataType: 'form'
    });
  },
  confirmOne(data) {
    return http.post({
      url: '/la/admin/purchase/sendGitOne',
      data,
      dataType: 'form'
    });
  },
  confirmMore(data) {
    return http.post({
      url: '/la/admin/purchase/sendGitAll',
      data,
      dataType: 'form'
    });
  }
};
